import { useMutation } from '@tanstack/react-query'

import { updateFreeeConnect } from '@src/api'
import { DefaultApiUpdateFreeeConnectRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'

export const useUpdateFreeeConnect = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateFreeeConnectRequest) =>
      updateFreeeConnect(axiosInstance, params),
  })
}
